import PropTypes from 'prop-types';

import style from './YoutubePlaceholder.module.scss';

const youtubeSet = [
  { name: 'default.jpg', size: '120w' },
  { name: 'mqdefault.jpg', size: '320w' },
  { name: 'hqdefault.jpg', size: '480w' },
  { name: 'sddefault.jpg', size: '640w' },
  { name: 'maxresdefault.jpg', size: '1280w' }
];

const buildYoutubeThumbnailSet = id => {
  const baseImageUrl = `https://img.youtube.com/vi/${id}`;

  return youtubeSet
    .map(set => `${baseImageUrl}/${set.name} ${set.size}`)
    .join(',');
};

const buildThumbnailSet = ({ detail_full_screen, detail_slider }) =>
  [
    detail_full_screen ? `${detail_full_screen} 1600w` : '',
    detail_slider ? `${detail_slider} 1152w` : ''
  ]
    .filter(Boolean)
    .join(', ');

const YoutubePlaceholder = ({ name, id, url, handleClick, thumbnail = {} }) => {
  const hasThumbnails = () =>
    Object.keys(thumbnail).length &&
    (thumbnail.detail_full_screen || thumbnail.detail_slider);

  const getThumbnailSet = () =>
    hasThumbnails()
      ? buildThumbnailSet(thumbnail)
      : buildYoutubeThumbnailSet(id);

  const handleLinkClick = e => {
    e && e.stopPropagation();
  };

  return (
    <div
      className={style['yt-video-placeholder']}
      onClick={handleClick}
      role="button"
      tabIndex="0"
    >
      <div className={style['yt-video-placeholder__mask']} />
      <picture>
        <img
          className={style['yt-video-placeholder__image']}
          height="100%"
          alt={name}
          srcSet={getThumbnailSet()}
          sizes="70%"
          src={`https://img.youtube.com/vi/${id}/maxresdefault.jpg`}
        />
      </picture>
      <a
        onClick={handleLinkClick}
        target="_blank"
        href={url}
        title={name}
        className={style['yt-video-placeholder__name']}
        rel="noreferrer"
      >
        {name}
      </a>
    </div>
  );
};

YoutubePlaceholder.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  thumbnail: PropTypes.shape({
    detail_full_screen: PropTypes.string,
    detail_slider: PropTypes.string
  })
};

export default YoutubePlaceholder;
